import { render } from "./ViewVScode.vue?vue&type=template&id=19d2da0d&scoped=true"
import script from "./ViewVScode.vue?vue&type=script&lang=js"
export * from "./ViewVScode.vue?vue&type=script&lang=js"

import "./ViewVScode.vue?vue&type=style&index=0&id=19d2da0d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d2da0d"]])

export default __exports__